import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import {CustomTabs, InputRow} from '../../../components'
import {getUserDataFromLocalStorage, onChangeInput, validateInputs} from "../../../services/utils";
import {useStyles} from "../../auth/signIn/authStyles";
import {initialState} from "./constant";
import Alert from "../../../components/alert";
import HttpService from "../../../services/http.service";
import axios from "axios";
import {measurementUnitsOption, searchAlertTypeOption,currencyOption, APP_DOMAIN_PREFIX} from "../../../environment";

export default function AddNewSearch(props) {
  const classes = useStyles();
  let user = getUserDataFromLocalStorage()
  const [state, setState] = useState(initialState);
  const [activeTab, setActiveTab] = useState(0);

  const handleChangeTab = (event, key) => {
    setActiveTab(key)
  }

  const {values, errors} = state;

  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [countries, setCountries] = useState([])
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [alertType, setAlertType] = useState([])
  const [yieldList, setYieldList] = useState([])
  let farming = JSON.parse(localStorage.getItem("farming") || "[]")
  const arr = []
  for (let i = 0; i < farming.length; i++) {
    arr.push({text: farming[i].agriSectorDescription, value: farming[i].agriSectorId})
  }
  //setSectorList(arr)
  useEffect(() => {
    let sectorId = values.searchCategory
    if (sectorId) {
      for (let j = 0; j < farming.length; j++) {
        if (farming[j].agriSectorId == sectorId) {
          const arry = []
          for (let i = 0; i < farming[j].categories.length; i++) {
            arry.push({
              text:
                sectorId == 1 ? farming[j].categories[i].cropName :
                  sectorId == 2 ? farming[j].categories[i].agriFisherySubSpeciesName :
                    sectorId == 3 ? farming[j].categories[i].liveStockCategoryDesc : "Farming",
              value:
                sectorId == 1 ? farming[j].categories[i].cropName :
                  sectorId == 1 ? farming[j].categories[i].agriFisherySubSpeciesName :
                    sectorId == 1 ? farming[j].categories[i].liveStockCategoryDesc : "Farming"
            })
          }
          setYieldList(arry)
        }
      }
    }

  }, [values.searchCategory]);
  useEffect(() => {
    console.log('change')
  }, [state])
  useEffect(() => {
    HttpService.get('apis/list/todoTypes/').then(res => {
      if (res) {

        const array = []
        for (let i = 0; i < res.data.length; i++) {
          array.push({text: res.data[i].activityName, value: res.data[i].myToDoActivitiesId})
        }
        setAlertType(array)
      }
    });
  }, []);
  useEffect(() => {
    setStateList([])
    HttpService.get('marketplace/countriesList').then(res => {
      if (res) {
        let list = res.data;
        let len = (list && list.length) || 0;
        const array = []
        for (let i = 0; i < len; i++) {
          array.push({text: list[i].countryName, value: list[i].countryID})
        }
        setCountries(array)
      }
    });
  }, []);
  useEffect(() => {
    // let country = "UAE"
    let country = values.country
    if (country) {
      HttpService.get(`marketplace/statesByCountry/${country}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].stateName, value: list[i].stateID})

          }
          setStateList(array)
        }
      });
    }

  }, [values.country]);
  useEffect(() => {
    // let state = "5347"
    let state = values.state
    // setCityList([])
    if (state) {
      HttpService.get(`marketplace/cityByStates/${state}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].cityName, value: list[i].cityName})
          }
          console.log(array)
          setCityList(array)
        }
      });
    }

  }, [values.state]);

  const addAlert = (e) => {
    e.preventDefault();

    let data = {
      ...values
    };

    let recordedErrors = validateInputs(data);

    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let searchType = activeTab ? "Product" : "Service"
      axios.post(`${APP_DOMAIN_PREFIX}/api/mysearches/save?city=${data.city}&country=${data.country}&keyword=${data.keyword}&searchSubCategory=${data.searchSubCategory}&searchCategory=${data.searchCategory}&priceFrom=${data.priceFrom}&priceTo=${data.priceTo}&qty=${data.qty}&qtyName=${data.qtyName}&searchType=${searchType}&ssoid=${user.ssoId}`).then(res => {
        if (res) {
          if (res?.data?.message === "SUCCESS")
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            setSuccess("")
          }, 5000);
        } else
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 5000);
      });
    }
  };


  return (
    <>
      {/*<Header/>*/}
      {((error || success)) &&
        <Alert type={error ? 'error' : 'success'}
               message={error || success}/>
      }

      <Container component="main" maxWidth={"lg"} className='mb-20 '>
        <div>
          <h1 className='align-self-start heading-color'>Create New Requirement</h1>
          {/*<Grid md={12} style={{borderBottom: '1px solid C4C4C4'}}>*/}
          <Grid lg={6} md={8} sm={12}>
            <CustomTabs
              activeTab={activeTab} handleChange={handleChangeTab}
              tabsList={[{label: 'product '}, {label: 'service '},]}/>
          </Grid>
          {/*</Grid>*/}
          <form className={classes.form} style={{marginTop: 20}}>
            <InputRow
              types={[
                {value: values.keyword, error: errors.keyword, id: 'keyword', label: 'Name'},
                {
                  type: 'select',
                  value: values.searchCategory,
                  error: errors.searchCategory,
                  label: 'product Category',
                  id: 'searchCategory',
                  dropdownList: arr
                }, {
                  type: 'select',
                  value: values.searchSubCategory,
                  error: errors.searchSubCategory,
                  label: 'product Type',
                  id: 'searchSubCategory',
                  dropdownList: yieldList
                },
                {type: 'number', min: 1, value: values.qty, error: errors.qty, id: 'qty', label: 'Quantity',},
                {
                  type: 'select',
                  value: values.qtyName,
                  error: errors.qtyName,
                  label: 'Measurement Unit',
                  id: 'qtyName',
                  dropdownList: measurementUnitsOption
                },
                {
                  type: 'select',
                  value: values.currency,
                  error: errors.currency,
                  label: 'currency',
                  dropdownList: currencyOption
                },
                {
                  type: 'select',
                  value: values.country,
                  error: errors.country,
                  label: 'country',
                  id: 'country',
                  dropdownList: countries
                }, {
                  type: 'select',
                  value: values.state,
                  error: errors.state,
                  label: 'state',
                  id: 'state',
                  dropdownList: stateList
                }, {
                  type: 'select',
                  value: values.city,
                  error: errors.city,
                  label: 'city',
                  id: 'city',
                  dropdownList: cityList
                },
                {type: 'date',  value: values.closingDate, error: errors.qty, id: 'closing_date', label: 'closing date',},

              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={3}
            />
            <p>Price Range:</p>
            <InputRow
              types={[
                {
                  type: 'number',
                  min: 0,
                  value: values.priceFrom,
                  error: errors.priceFrom,
                  id: 'priceFrom',
                  label: ' Price from ',
                },
                {
                  type: 'number',
                  min: 0,
                  value: values.priceTo,
                  error: errors.priceTo,
                  id: 'priceTo',
                  label: 'Price to',
                },

              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={3}
            />

            <Grid container spacing={2} className='mt-30 mb-20 pl-10  pr-10'>
              <Button type="submit" variant="contained" color="primary"
                      onClick={(e) => addAlert(e)}>
                Save New Search
              </Button>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
